import type { FC } from 'react';

import { FORM_KEY } from 'constants/form-ids';
import { twMergeClsx } from 'utils/tw-with-clsx';

interface DotLoaderProps {
  formKey?: string;
  className?: string;
}

const DotLoader: FC<DotLoaderProps> = ({ formKey = 'default', className }) => {
  const baseStyle = 'w-2 h-2 rounded-full';
  const backgroundColor = twMergeClsx(
    formKey === 'default' && 'bg-white',
    formKey === FORM_KEY.SZ && 'bg-sz-blue-100',
    formKey === FORM_KEY.XBET && 'bg-black',
    formKey === FORM_KEY.FONBET && 'bg-fonbet-blue-100',
    className,
  );

  const baseCircle = 'mr-4 animate-move';
  const firstChildStyle = 'absolute top-0 left-0 animate-grow';
  const lastChildStyle = 'absolute top-0 right-0 animate-grow-reverse';

  return (
    <div className="flex relative w-14 h-2">
      <span className={`${baseStyle} ${backgroundColor} ${firstChildStyle}`} />
      <span className={`${baseStyle} ${backgroundColor} ${baseCircle}`} />
      <span className={`${baseStyle} ${backgroundColor} ${baseCircle}`} />
      <span className={`${baseStyle} ${backgroundColor} ${lastChildStyle}`} />
    </div>
  );
};

export { DotLoader };
